import { __decorate } from "tslib";
import { element as ngElement } from 'angular';
import { Injectable } from 'angular-ts-decorators';
var EventHelperService = (function () {
    function EventHelperService() {
    }
    EventHelperService.prototype.setLazy = function (element) {
        var selector = 'img[data-src],iframe[data-src]';
        if (typeof element === 'object') {
            element.find(selector).lazyLoadXT();
        }
        else {
            ngElement(selector).lazyLoadXT();
        }
        return this;
    };
    EventHelperService.prototype.triggerScroll = function () {
        window.scrollTo(window.pageXOffset, window.pageYOffset + 1);
        window.scrollTo(window.pageXOffset, window.pageYOffset - 1);
        return this;
    };
    EventHelperService.prototype.triggerResize = function () {
        var evt = document.createEvent('Event');
        evt.initEvent('resize', true, true);
        window.dispatchEvent(evt);
        return this;
    };
    EventHelperService.$inject = [];
    EventHelperService = __decorate([
        Injectable('eventHelper')
    ], EventHelperService);
    return EventHelperService;
}());
export { EventHelperService };
